'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _colors = require('../../../constants/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CheckBadgeIcon = function (_React$Component) {
    _inherits(CheckBadgeIcon, _React$Component);

    function CheckBadgeIcon() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, CheckBadgeIcon);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CheckBadgeIcon.__proto__ || Object.getPrototypeOf(CheckBadgeIcon)).call.apply(_ref, [this].concat(args))), _this), _this.getIcon = function (width, height, primary, secondary) {
            return _react2.default.createElement(
                'svg',
                { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 91.058 91.011' },
                _react2.default.createElement(
                    'g',
                    { id: 'streamline-icon-check-badge_40x40', 'data-name': 'streamline-icon-check-badge@40x40', transform: 'translate(1.255 1.255)' },
                    _react2.default.createElement('path', { id: 'Path_42457', 'data-name': 'Path 42457', fill: 'none', stroke: primary, d: 'M43.25,16.248,27.591,37.126a2.959,2.959,0,0,1-4.445.315l-9.4-9.393', transform: 'translate(15.772 19.153)', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', strokeWidth: '2.5' }),
                    _react2.default.createElement('path', { id: 'Path_42458', 'data-name': 'Path 42458', fill: 'none', stroke: secondary, d: 'M40.517,3.641a6.411,6.411,0,0,1,9.015-.975,6.535,6.535,0,0,1,.975.975l5.947,7.4a6.4,6.4,0,0,0,5.688,2.36l9.44-1.027a6.41,6.41,0,0,1,7.08,5.664,6.554,6.554,0,0,1,0,1.416l-1.027,9.44A6.4,6.4,0,0,0,80,34.58l7.4,5.947a6.411,6.411,0,0,1,.975,9.015,6.534,6.534,0,0,1-.975.975l-7.422,5.92a6.414,6.414,0,0,0-2.36,5.692l1.027,9.44a6.408,6.408,0,0,1-5.656,7.08,6.627,6.627,0,0,1-1.424,0l-9.44-1.027a6.4,6.4,0,0,0-5.688,2.36l-5.924,7.371a6.407,6.407,0,0,1-9.991,0l-5.943-7.395a6.41,6.41,0,0,0-5.692-2.36l-9.44,1.027a6.4,6.4,0,0,1-7.08-5.648,6.225,6.225,0,0,1,0-1.432l1.027-9.44a6.41,6.41,0,0,0-2.36-5.692L3.635,50.471a6.407,6.407,0,0,1,0-9.991l7.395-5.947a6.4,6.4,0,0,0,2.36-5.688l-1.027-9.44a6.408,6.408,0,0,1,5.656-7.08,6.628,6.628,0,0,1,1.424,0l9.44,1.027a6.414,6.414,0,0,0,5.692-2.36Z', transform: 'translate(-1.241 -1.248)', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', strokeWidth: '2.5' })
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(CheckBadgeIcon, [{
        key: 'render',
        value: function render() {
            var size = this.props.size || 91;
            return this.getIcon(size, size, _colors.Colors.Primary, _colors.Colors.Secondary);
        }
    }]);

    return CheckBadgeIcon;
}(_react2.default.Component);

exports.default = CheckBadgeIcon;